<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-volume-up', fontSet: 'fad'}"
	[headerText]="data.masterOfCeremonyMapping.name + (T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TITLE | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="contentContainer">
			<div class="col-4">
				<!-- =============================================== A2R Input ========================================= -->
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getInputChannelName.bind(this)"
					(removeEntryEmitter)="removeChannel($event, data.masterOfCeremonyMapping.vogInputChannelIds)"
					[scrollEntries]="data.masterOfCeremonyMapping.vogInputChannelIds"
					[scrollContainerHeightInPX]="200"
				>
					<mat-form-field color="accent" style="width: 100%">
						<mat-label>{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_VOG | translate }}</mat-label>
						<mat-select
							(ngModelChange)="addChannel($event, data.masterOfCeremonyMapping.vogInputChannelIds)"
							[(ngModel)]="vogInputChannelId"
						>
							<mat-option [value]="null">{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_VOG | translate }}</mat-option>
							@for (
								availableVogAudioInputChannel of filteredVogInputChannels ?? filterVogInputChannels();
								track availableVogAudioInputChannel
							) {
								<mat-option [value]="availableVogAudioInputChannel.id">
									{{ availableVogAudioInputChannel.displayAdminText }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>

				<!-- ============================================== A2R Network Input ======================================== -->
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getNetworkChannelName.bind(this)"
					(removeEntryEmitter)="removeChannel($event, data.masterOfCeremonyMapping.vogNetworkAudioInputChannelIds)"
					[scrollEntries]="data.masterOfCeremonyMapping.vogNetworkAudioInputChannelIds"
					[scrollContainerHeightInPX]="200"
				>
					<mat-form-field color="accent" style="width: 100%">
						<mat-label>
							{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VOG_NETWORK | translate }}
						</mat-label>
						<mat-select
							(ngModelChange)="addChannel($event, data.masterOfCeremonyMapping.vogNetworkAudioInputChannelIds)"
							[(ngModel)]="vogNetworkInputChannelId"
							style="width: 100%"
						>
							<mat-option [value]="null">
								{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NETWORK_VOG | translate }}
							</mat-option>
							@for (
								availableVogNetworkInputChannel of filteredVogNetworkInputChannels ?? filterVogNetworkInputChannels();
								track availableVogNetworkInputChannel
							) {
								<mat-option [value]="availableVogNetworkInputChannel.id">
									{{ availableVogNetworkInputChannel.displayAdminText }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>
			</div>

			<div class="col-4">
				<!-- =============================================== AoP Input ========================================= -->
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getInputChannelName.bind(this)"
					(removeEntryEmitter)="removeChannel($event, data.masterOfCeremonyMapping.vopInputChannelIds)"
					[scrollEntries]="data.masterOfCeremonyMapping.vopInputChannelIds"
					[scrollContainerHeightInPX]="200"
				>
					<mat-form-field color="accent" style="width: 100%">
						<mat-label>{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_VOP | translate }}</mat-label>
						<mat-select
							(ngModelChange)="addChannel($event, data.masterOfCeremonyMapping.vopInputChannelIds)"
							[(ngModel)]="vogInputChannelId"
						>
							<mat-option [value]="null">{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_VOP | translate }}</mat-option>
							@for (
								availableVopAudioInputChannel of filteredVopInputChannels ?? filterVopInputChannels();
								track availableVopAudioInputChannel
							) {
								<mat-option [value]="availableVopAudioInputChannel.id">
									{{ availableVopAudioInputChannel.displayAdminText }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>

				<!-- ============================================== AoP Network Input ======================================== -->
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getNetworkChannelName.bind(this)"
					(removeEntryEmitter)="removeChannel($event, data.masterOfCeremonyMapping.vopNetworkAudioInputChannelIds)"
					[scrollEntries]="data.masterOfCeremonyMapping.vopNetworkAudioInputChannelIds"
					[scrollContainerHeightInPX]="200"
				>
					<mat-form-field color="accent" style="width: 100%">
						<mat-label>
							{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VOP_NETWORK | translate }}
						</mat-label>
						<mat-select
							(ngModelChange)="addChannel($event, data.masterOfCeremonyMapping.vopNetworkAudioInputChannelIds)"
							[(ngModel)]="vopNetworkInputChannelId"
							style="width: 100%"
						>
							<mat-option [value]="null">
								{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NETWORK_VOP | translate }}
							</mat-option>
							@for (
								availableVopNetworkInputChannel of filteredVopNetworkInputChannels ?? filterVopNetworkInputChannels();
								track availableVopNetworkInputChannel
							) {
								<mat-option [value]="availableVopNetworkInputChannel.id">
									{{ availableVopNetworkInputChannel.displayAdminText }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>
			</div>

			<div class="col-4">
				<!-- =============================================== AoP Input ========================================= -->
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getInputChannelName.bind(this)"
					(removeEntryEmitter)="removeChannel($event, data.masterOfCeremonyMapping.vttInputChannelIds)"
					[scrollEntries]="data.masterOfCeremonyMapping.vttInputChannelIds"
					[scrollContainerHeightInPX]="200"
				>
					<mat-form-field color="accent" style="width: 100%">
						<mat-label>{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_VTT | translate }}</mat-label>
						<mat-select
							(ngModelChange)="addChannel($event, data.masterOfCeremonyMapping.vttInputChannelIds)"
							[(ngModel)]="vogInputChannelId"
						>
							<mat-option [value]="null">{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_VTT | translate }}</mat-option>
							@for (
								availableVttAudioInputChannel of filteredVttInputChannels ?? filterVttInputChannels();
								track availableVttAudioInputChannel
							) {
								<mat-option [value]="availableVttAudioInputChannel.id">
									{{ availableVttAudioInputChannel.displayAdminText }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>

				<!-- ============================================== AoP Network Input ======================================== -->
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getNetworkChannelName.bind(this)"
					(removeEntryEmitter)="removeChannel($event, data.masterOfCeremonyMapping.vttNetworkAudioInputChannelIds)"
					[scrollEntries]="data.masterOfCeremonyMapping.vttNetworkAudioInputChannelIds"
					[scrollContainerHeightInPX]="200"
				>
					<mat-form-field color="accent" style="width: 100%">
						<mat-label>
							{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VTT_NETWORK | translate }}
						</mat-label>
						<mat-select
							(ngModelChange)="addChannel($event, data.masterOfCeremonyMapping.vttNetworkAudioInputChannelIds)"
							[(ngModel)]="vttNetworkInputChannelId"
							style="width: 100%"
						>
							<mat-option [value]="null">
								{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NETWORK_VTT | translate }}
							</mat-option>
							@for (
								availableVttNetworkInputChannel of filteredVttNetworkInputChannels ?? filterVttNetworkInputChannels();
								track availableVttNetworkInputChannel
							) {
								<mat-option [value]="availableVttNetworkInputChannel.id">
									{{ availableVttNetworkInputChannel.displayAdminText }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>
			</div>
		</div>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="saveRecorderMapping()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
